import { Provider } from 'react-redux'
import { BrowserRouter as Router } from "react-router-dom";
import Routings from "@/router";
import { HelmetProvider } from 'react-helmet-async';
import { store } from '@/store'
import './styles/css/main.css';
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer } from 'react-toastify';
import { setDefaultLocale } from  "react-datepicker";

setDefaultLocale('ja')

function App() {
  return (
    <Provider store={store}>
      <HelmetProvider>
        <Router>
          <Routings />
          <ToastContainer />
        </Router>
      </HelmetProvider>
    </Provider>
  )
}

export default App
